export default __webpack_public_path__ + "static/media/Bedroom2.705cf555.png";